/*eslint-disable*/ export const messages = JSON.parse("{\"radio-group.label.optional\":[\"Optional\"],\"radio-group.validation.required\":[\"Please select an option.\"]}");
//# sourceMappingURL=messages.mjs.map